<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X5lCmk/images/MyCoverImage.jpg?1734367787390" alt="This image is the cover for the book Last Cavalier"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Cavalier
      </h1>
      <p class="bookDescription body article font2">
        <b>A Confederate soldier plunges through a portal in time . . . into the future and into the arms of a modern woman</b><br/><br/> Confederate cavalry captain Jason Tarkenton is fighting the battle of his life, desperate to save his fellow comrades-in-arms from their hated Yankee enemies. Suddenly, he hears a thunderous crack in the sky. The earth beneath his feet begins to shift as he is engulfed in darkness and mist.<br/><br/> Virginian Vickie Knox has spent most of her life listening to her grandfather’s tales about the Civil War. To humor his obsession, she agrees to don authentic garb for their farming town’s reenactment of a battle. But the stranger in rebel uniform who accosts her and takes her captive isn’t part of the festivities. He’s the real deal—a soldier in Robert E. Lee’s army who left unfinished business back in 1862.<br/><br/> Neither of them expects to fall in love. If Jason returns to the past, he could change the course of history—and risk losing Vickie forever. Unless she is willing to gamble her future on a love stronger than time itself . . .<br/><br/> This ebook features an illustrated biography of Heather Graham, including rare photos from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Graham
      </h2>
      
      <p class="authorDescription body article">Heather Graham (b. 1953) is a bestselling author of more than 150 romance, suspense, and historical novels that have sold seventy-five million copies worldwide. Raised in Florida, Graham went to college for theater arts, and spent several years acting, singing, and bartending before she devoted herself to writing. Her first novel, <i>When Next We Love</i>, was published in 1982. Although she became famous as an author of romance novels, Graham has since branched out into supernatural horror, historical fiction, and suspense, with titles such as <i>Tall, Dark, and Deadly </i>(1999), <i>Long, Lean, and Lethal </i>(2000), and<i> Dying to Have Her </i>(2001). In 2003 the Romance Writers of America, whose Florida chapter Graham founded, granted her a lifetime achievement award. She lives, writes, and scuba dives in Florida with her husband and five children. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f18f466e